import { useMemo } from 'react';
import { pick } from 'js/utils/ramda.util';

import * as helpers from '../helpers';
import { LAST_SIX_MONTHS_VALUE } from '../constants';
import { useDynamicReducerSelector } from '../store';

export const useVisualDates = () => {
    const {
        period, startDate, endDate
    } = useDynamicReducerSelector(pick([
        'period', 'startDate', 'endDate'
    ]));

    const isSixMonthPeriod = period === LAST_SIX_MONTHS_VALUE;
    const { startDate: startDateSecondBulk } = helpers.getSecondBulkForSixMonthsDates();

    return useMemo(() => ({
        endTime: endDate,
        startTime: isSixMonthPeriod ? startDateSecondBulk : startDate
    }), [isSixMonthPeriod, startDateSecondBulk, startDate, endDate]);
};
